function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #melaoSVG .cls-1 {\n        fill: none;\n        stroke: #f5f5f5;\n        stroke-miterlimit: 10;\n      }\n\n      #melaoSVG .cls-2 {\n        fill: url(#Gradiente_sem_nome_408);\n      }\n\n      #melaoSVG .cls-3 {\n        fill: #f5f5f5;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Gradiente_sem_nome_408",
  "data-name": "Gradiente sem nome 408",
  x1: 0.5,
  y1: 25.5,
  x2: 50.5,
  y2: 25.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#ffcd76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.94,
  stopColor: "#fbae71"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "melaoSVG",
  "data-name": "Camada 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Fundo_Mel\\xE3o",
  "data-name": "Fundo Mel\\xE3o"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 25.5,
  cy: 25.5,
  r: 25
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 25.5,
  cy: 25.5,
  r: 25
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M33.41,15.91a10.57,10.57,0,0,1-15.88,0L8.06,25.41a24.62,24.62,0,0,0,34.83,0l0,0ZM21.1,20.72A6.07,6.07,0,0,1,20.25,23a1.43,1.43,0,0,1-2-2,6.26,6.26,0,0,1,2.3-.85.47.47,0,0,1,.57.35A.37.37,0,0,1,21.1,20.72Zm4.36,5.78A1.42,1.42,0,0,1,24,25.08a6.47,6.47,0,0,1,1-2.24.48.48,0,0,1,.66-.15.54.54,0,0,1,.15.15,6.87,6.87,0,0,1,1,2.24A1.42,1.42,0,0,1,25.46,26.5ZM32.67,23a1.44,1.44,0,0,1-2,0,6.42,6.42,0,0,1-.86-2.31.48.48,0,0,1,.36-.56.38.38,0,0,1,.21,0,5.91,5.91,0,0,1,2.31.85,1.43,1.43,0,0,1,0,2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M25.48,37.07A28.27,28.27,0,0,1,5.37,28.72l1.34-1.34a26.54,26.54,0,0,0,37.51,0l0,0,1.34,1.34A28.28,28.28,0,0,1,25.48,37.07Z"
})), /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 25.5,
  cy: 25.5,
  r: 25
})));

function SvgMelao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMelao);
export default __webpack_public_path__ + "static/media/Melao.21757d3f.svg";
export { ForwardRef as ReactComponent };